module.exports = __webpack_public_path__ + "img/icon-success.2d1ca6db.png";